import styled from 'styled-components';
import {
  Flex,
} from 'web-styled';
import {
  Link,
} from 'react-router-dom';

export const Item = styled(Flex).attrs({
  flex: '0 0 70px',
  justify: 'space-between',
  align: 'center',
  shrink: 0,
})`
  margin: 0;
  width: 100%;
  padding: 15px;
  border-bottom: 1px solid #ededed;

  &:first-of-type {
    margin-top: 10px;
  }

  &:hover {
    background: #fbfbfb;
  }

  &:hover div:last-of-type {
    display: flex;
  }

  &:hover strong:last-of-type {
    display: none;
  }
`;

export const Name = styled(Link)`
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${props => props.theme.colors.link};
  line-height: 30px;

  & > i {
    margin: 0 5px;
    width: 23px;
    height: 13px;
  }
`;

export const Time = styled.span`
  color: #404447;
  font-size: 14px;
  line-height: 30px;
  width: 100px;
  text-align: right;
`;

export const Empty = styled(Flex).attrs({
  column: true,
  spacing: 10,
  align: 'center',
  justify: 'center',
})`
  width: 100%;
  height: 100%;
  color: #ccc;
  text-align: center;
  font-size: 12px;
`;

export const EmptyIcon = styled.img`
  width: 46px;
  height: 54px;
  filter: invert(78%) sepia(5%) saturate(27%) hue-rotate(251deg) brightness(98%) contrast(107%);
`;
